import { useModuleRedirect } from "../../hooks/useModuleRedirect";

const ExternalEmergencyPreparednessEntry = () => {
  useModuleRedirect("external-emergency-preparedness-module");
  return null;
};

export default ExternalEmergencyPreparednessEntry;
